exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd.narrow{\n    width:15% !important;\n}\ntd:first-child {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\nth{\n    text-align:left !important;\n}\n", ""]);

// exports
